/**
 * Screen types that trigger AI diagnosis suggestions when saved in EMR charts
 * Add or remove screen types from this array to control which sections trigger AI calls
 */
export const AI_TRIGGER_SCREEN_TYPES = [
  'HPI',
  'SUBJECTIVE_HPI',
  'PMH',
  'SUBJECTIVE_PMH',
  'MUSCULOSKELETAL',
];

/**
 * Screen types to fetch history data from when generating AI suggestions
 * These are the screen types that will be included in the AI prompt
 */
export const AI_HISTORY_SCREEN_TYPES = [
  'HPI',
  'SUBJECTIVE_HPI',
  'PMH',
  'SUBJECTIVE_PMH',
  'MUSCULOSKELETAL',
];


